module.exports = __webpack_public_path__ + "media/images/icons/outlined/borderless-table-d1b026b8a686648679e409dae828052a.svg";